(function () {

  'use strict';

  function pxPaginatedFilter(
    $timeout, NetworkListService, NetworkListPaging, FilterDropdownService, TenantListService, OnDeviceConfigService, GoProfilePaging, GoProfileService, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        filtersInDropdown: '=filtersInDropdown',
        index: '=index',
        filterModel: '=filterModel',
        filter: '=filter',
        callback: '&callback',
        pagingObject: '=pagingObject',
        returnFilterMap: '&returnFilterMap'
      },
      templateUrl: 'app/directives/filterDirectives/filterDropdownDirective/paginatedFilter/paginatedFilter.template.html',
      link: function (scope) {

        scope.totalPages = null;
        scope.loadingFilterPage = true;

        var pageService = null;
        var pageObject = null;
        var providerEndpoint = null;
        var scrollEnd = null;
        var containerHeight = null;

        (function () {
          setResourceScope();
          bindScrollElement();
          getFirstPage();
        })();

        function setResourceScope() {
          switch (scope.filter.service) {
            case 'NetworkListService':
              pageService = NetworkListService;
              providerEndpoint = 'getNetworkListPaged';
              pageObject = scope.pagingObject || new NetworkListPaging();
              break;
            case 'OnDeviceConfigService':
              pageService = OnDeviceConfigService;
              providerEndpoint = 'getOnDeviceConfigsList';
              pageObject = new GoProfilePaging();
              break;
            case 'GoProfileService':
              pageService = GoProfileService;
              providerEndpoint = 'getGoProfilePaged';
              pageObject = new GoProfilePaging();
              break;
          }

          pageObject.pagingCriteria.pageSize = 10;
        }

        function getFirstPage() {
          scope.loadingFilterPage = true;
          pageObject.pagingCriteria.page = 0;
          pageService[providerEndpoint](pageObject).then(function (pagedContent) {
            scope.loadingFilterPage = false;
            scope.totalPages = pagedContent.page.totalPages;

            switch (scope.filter.service) {
              case 'NetworkListService':
                networkFirstPageExceptions(pagedContent);
                break;
              default:
                scope.filter.values = FilterDropdownService.getFilterKeyValuePairArray(pagedContent.list, 'POST', null);
            }

            scope.returnFilterMap({ filtersInDropdown: scope.filtersInDropdown });
          }).catch(function(error){});
        }

        function networkFirstPageExceptions(pagedContent) {
          pagedContent.list.forEach(network => {
            network.info.supportIcon = !!network.info.airPrint;
          });

          scope.filter.values = FilterDropdownService.getFilterKeyValuePairArray(pagedContent.list, 'POST',
            (TenantListService.currentTenant.info.mobilePrint ? 'icon-mobile-plain' : null));
        }

        scope.textSearch = function () {
          pageObject.pagingCriteria.match = scope.searchPattern.string.toLowerCase();
          getFirstPage();
        };

        function getNextPage() {
          if (!scope.loadingFilterPage && (scope.totalPages > pageObject.pagingCriteria.page + 1)) {
            scope.loadingFilterPage = true;
            pageObject.pagingCriteria.page += 1;
            pageService[providerEndpoint](pageObject).then(function (pagedContent) {
              scope.loadingFilterPage = false;

              switch (scope.filter.service) {
                case 'NetworkListService':
                  networkNextPageExceptions(pagedContent);
                  break;
                default:
                  scope.filter.values = scope.filtersInDropdown[scope.index].values.concat(FilterDropdownService.getFilterKeyValuePairArray(pagedContent.list, 'POST', null));
              }

              scope.returnFilterMap({ filtersInDropdown: scope.filtersInDropdown });
            }).catch(function(error){});
          }
        }

        function networkNextPageExceptions(pagedContent) {
          pagedContent.list.forEach(network => {
            network.info.supportIcon = !!network.info.airPrint;
          });

          scope.filter.values = scope.filtersInDropdown[scope.index].values.concat(FilterDropdownService.getFilterKeyValuePairArray(pagedContent.list, 'POST',
            (TenantListService.currentTenant.info.mobilePrint ? 'icon-mobile-plain' : null)));
        }

        var scrollbar = '#' + scope.filter.parameter + '_' + scope.index;

        function bindScrollElement() {
          $timeout(() => {
            angular.element(scrollbar).on('scroll', function (event) {
              scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
              containerHeight = event.currentTarget.scrollHeight;

              if (!scope.loadingFilterPage && scope.totalPages > pageObject.pagingCriteria.page + 1) {
                if (scrollEnd > containerHeight) {
                  $timeout(function () {
                    getNextPage();
                  }, 300);
                }
              }
            });
          }, 100);
        }

        scope.updateSelectedFilters = function () {
          scope.callback({ filterModel: scope.filterModel });
        };

        scope.$on('$destroy', function () {
          angular.element(scrollbar).off('scroll');
        });

        angular.element('.dropdown-label').on('click', function (event) {
          event.stopPropagation();
        });

      }
    };
  }

  pxPaginatedFilter.$inject = [
    '$timeout', 'NetworkListService', 'NetworkListPaging', 'FilterDropdownService', 'TenantListService', 'OnDeviceConfigService', 'GoProfilePaging', 'GoProfileService', '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxPaginatedFilter', pxPaginatedFilter);

})();
